const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUxMyAzNDIiPgo8cmVjdCB5PSIwIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjM0MiIvPgo8ZyBmaWxsPSIjQTIwMDFEIj4KCTxyZWN0IHk9IjAiIGNsYXNzPSJzdDEiIHdpZHRoPSI1MTMiIGhlaWdodD0iMTI3LjYiLz4KCTxyZWN0IHg9IjAiIHk9IjIxNC40IiBjbGFzcz0ic3QxIiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjEyNy42Ii8+CjwvZz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=LV-37210d3e.mjs.map
